export default __webpack_public_path__ + "9b815622fab8819f254391fc0d17679f.png";